<template>
<transition name="fade">
    <div class="loading-main">
        <div class="loading" :class="{'show':isShow}">
            <div class="loading-gif animation_x"></div>
            <p>loading...</p>
        </div>
    </div>
</transition>
</template>
<script>
export default {
    data() {
        return {
            isShow:false,
            msg: 'loading'
        }
    },
    mounted(){
        setTimeout(()=>{
            this.isShow=true
        },0)
    }
}
</script>
<style lang="scss" scoped>
.loading-gif {
    position: relative;
    margin: 0 auto;
    margin-top: 25px;
    width: 24px;
    height: 24px;
    background-image: url('../../assets/images/flat/pc/loading-bg.png');
    -webkit-background-size: 100% 100%;
    -moz-background-size: 100% 100%;
    -o-background-size: 100% 100%;
    background-size: 100% 100%;
}
.animation_x {
    -webkit-animation: 0.975s linear infinite backwards;
    -webkit-animation-name: loadDemo;
    -moz-animation: 0.975s linear infinite backwards;
    -moz-animation-name: loadDemo;
    -ms-animation: 0.975s linear infinite backwards;
    -ms-animation-name: loadDemo;
    -o-animation: 0.975s linear infinite backwards;
    -o-animation-name: loadDemo;
    animation: 0.975s linear infinite backwards;
    animation-name: loadDemo;
}
@-webkit-keyframes loadDemo {
    0% {
        -webkit-transform:rotate(0deg);
        -ms-transform:rotate(0deg);
        -moz-transform:rotate(0deg);
        -o-transform:rotate(0deg);
        transform:rotate(0deg);
    }
    100% {
        -webkit-transform:rotate(360deg);
        -moz-transform:rotate(360deg);
        -ms-transform:rotate(360deg);
        -o-transform:rotate(360deg);
        transform:rotate(360deg);

    }
}
.loading-main{
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 100;
}
.loading {
    width: 100px;
    height: 100px;
    background: rgba(0,0,0,0.75);
    position: fixed;
    z-index: 99;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%,-50%);
    -moz-transform: translate(-50%,-50%);
    -ms-transform: translate(-50%,-50%);
    -o-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
    text-align: center;
    -webkit-border-radius: 10px;
    -moz-border-radius: 10px;
    border-radius: 10px;
    -webkit-transition: 0.75s;
    -o-transition: 0.75s;
    -ms-transition: 0.75s;
    -moz-transition: 0.75s;
    transition: 0.75s;

    opacity: 0;
    p{
        padding-top: 10px;
        color: #efefef;
        font-size: 16px;
    }
}
.show{
    opacity: 1;
}
.fade-enter-active,
.fade-leave-active {
    -webkit-transition: opacity 3.5s;
    -o-transition: opacity 3.5s;
    -moz-transition: opacity 3.5s;
    -ms-transition: opacity 3.5s;
    transition: opacity 3.5s;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// index.vue?794eeb9f